'use client';
import React from 'react';
import { getIconBaseUrl } from '../../utils/assets';
import styles from './SliderArrows.module.scss';
import cx from 'classnames';
const SRText = ({ children }) => (<span className='srOnly'>{children}</span>);
export const SliderArrows = ({ className, noPosition, prevOnClick, nextOnClick, altPrefix = 'Slide', }) => (<div className={cx(styles.container, {
        [styles.noPositioning]: noPosition,
    }, className)}>
    <button className={`${styles.button} ${styles.prev}`} onClick={prevOnClick} type='button'>
      <img className={styles.chevron} src={getIconBaseUrl('arrow-ios-left.svg')} alt={`Previous ${altPrefix}`}/>
      <SRText>Previous {altPrefix}</SRText>
    </button>
    <div className={styles.divider}/>
    <button className={`${styles.button} ${styles.next}`} onClick={nextOnClick} type='button'>
      <img className={styles.chevron} src={getIconBaseUrl('arrow-ios-right.svg')} alt={`Next ${altPrefix}`}/>
      <SRText>Next {altPrefix}</SRText>
    </button>
  </div>);
